import { createContext, useContext, useRef } from "react";

const ModalPopupManagerContext = createContext();

export const ModalPopupManagerProvider = ({ children }) => {
  const activeModalRef = useRef(null);

  const registerModal = (modalInstance, isCloseOther = false) => {
    if (activeModalRef.current && isCloseOther === true) {
      activeModalRef.current.hide();
      activeModalRef.current = null;
    }
    activeModalRef.current = modalInstance;
  };

  const closeActiveModal = () => {
    if (activeModalRef.current) {
      activeModalRef.current.hide();
      activeModalRef.current = null;
    }
  };

  return (
    <ModalPopupManagerContext.Provider
      value={{ registerModal, closeActiveModal }}
    >
      {children}
    </ModalPopupManagerContext.Provider>
  );
};

export const useModalPopupManager = () => useContext(ModalPopupManagerContext);
